import getI18n from '@/i18n/i18n'
import { i18n } from 'i18next'
import { useEffect, useState } from 'react'
import { I18nextProvider } from 'react-i18next'

export const TranslationsProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [i18nInstance, setI18nInstance] = useState<i18n | null>()

  const fetchTranslations = async () => {
    const i18n = getI18n()
    setI18nInstance(i18n)
  }

  useEffect(() => {
    fetchTranslations()
  }, [])

  return (
    <>
      {i18nInstance ? (
        <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>
      ) : null}
    </>
  )
}
